/* eslint-disable no-unused-vars */
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    scores: {
      // opening: {},
      // teams: {},
      // process: {},
      // technology: {},
    },
    totals: {},
    grades: {},
    scores: {},
    // answered: {},
    answered: [], // array of answers where position in the array denotes step
    currentPath: 'opening', // name of key to fetch questions from
    percentage: {},
    textresponses: {},
    activeSection: {}, // currently active section
    navPath: 0, // Where on the navigation tree the user should be.
    navStep: 0, // Position on the path the user currently is
    nav: [
      [ // initial path to determine where to send users
        // { component: 'Results', name: 'Results'},
        { component: 'Home', name: 'Home' },
        { component: 'Opening', name: 'Role', question: 0, path: [0, 1], setPath: true}
      ],
      // Order here determines question order/step order
      [ // path 1 (key 1)
        { component: 'Opening', name: 'Opening', question: 0, path: [1,0]},
        { component: 'Opening', name: 'Opening', question: 1, path: [1,1]},
        { component: 'Efficiency', name: 'Efficiency', question: 2, path: [1,2]},
        { component: 'Efficiency', name: 'Efficiency', question: 3, path: [1,3]},
        { component: 'Efficiency', name: 'Efficiency', question: 4, path: [1,4]},
        { component: 'Control', name: 'Control', question: 5, path: [1,5]},
        { component: 'Control', name: 'Control', question: 6, path: [1,6]},
        { component: 'Visibility', name: 'Visibility', question: 7, path: [1,7]},
        { component: 'Visibility', name: 'Visibility', question: 8, path: [1,8]},
        { component: 'Results', name: 'Results'},
      ],
      [ // path 2 (key 2)
        { component: 'Opening', name: 'Opening', question: 0, path: [2,0]},
        { component: 'Opening', name: 'Opening', question: 1, path: [2,1]},
        { component: 'Efficiency', name: 'Efficiency', question: 2, path: [2,2]},
        { component: 'Efficiency', name: 'Efficiency', question: 3, path: [2,3]},
        { component: 'Efficiency', name: 'Efficiency', question: 4, path: [2,4]},
        { component: 'Control', name: 'Control', question: 5, path: [2,5]},
        { component: 'Control', name: 'Control', question: 6, path: [2,6]},
        { component: 'Visibility', name: 'Visibility', question: 7, path: [2,7]},
        { component: 'Visibility', name: 'Visibility', question: 8, path: [2,8]},
        { component: 'Results', name: 'Results'},
      ],
      [ // path 3 (key 3)
        { component: 'Opening', name: 'Opening', question: 0, path: [3,0]},
        { component: 'Opening', name: 'Opening', question: 1, path: [3,1]},
        { component: 'Efficiency', name: 'Efficiency', question: 2, path: [3,2]},
        { component: 'Efficiency', name: 'Efficiency', question: 3, path: [3,3]},
        { component: 'Efficiency', name: 'Efficiency', question: 4, path: [3,4]},
        { component: 'Efficiency', name: 'Efficiency', question: 5, path: [3,5]},
        { component: 'Control', name: 'Control', question: 6, path: [3,6]},
        { component: 'Control', name: 'Control', question: 7, path: [3,7]},
        { component: 'Visibility', name: 'Visibility', question: 8, path: [3,8]},
        { component: 'Results', name: 'Results'},
      ],
    ],
    contact: {},
    submitted: [false],
  },
  actions: {

    // calculatePreviousStep({ commit, state }) {

    //   // Determine where in the navigation path the user currently is
    //   if ( state.navStep > 0 ) {
    //     // return state.navStep - 1;

    //   } else {
    //     if ( state.navStep === 0 & state.navPath > 0) {
    //       // return

    //     }

    //   }

    // },

    pushAnswer({ commit }, payload) {
      commit('pushAnswer', payload);

    },

    setActivePath({ commit }, payload) {
      commit('setNavPath', payload);
      commit('setActiveSection', this.state.nav[payload][this.getters.getNavPath]);

    },

    setActiveStep({ commit }, payload) {
      ('setting active step', payload);
      commit('setNavStep', payload);

      // every time the step changes, set that step as the currently active one
      commit('setActiveSection', this.state.nav[this.getters.getNavPath][payload]);

    },

    // Legacy actions
    setName({ commit }, { group, name }) {
      commit('setName', { group, name });
    },
    setScore({ commit }, payload) {
      commit('setScore', payload);
    },
    updateScoring({ commit }, payload) {
      const { group, passinggrade, scores } = payload;
      // if (!scores || !scores[group]) { console.log('nowork :('); return; }
      const scoreGroup = Object.values(scores[group]);
      if (scoreGroup.filter((a) => a === 0).length === 0) {
        commit('setAnswered', { group, check: true });
      }
      const sectionTotal = scoreGroup.reduce((total, score) => total + score);
      commit('updateSectionScore', { group, sectionTotal });
      let passed = false;
      if (sectionTotal >= passinggrade) { passed = true; }
      const perc = sectionTotal / (scoreGroup.length * 5);
      // console.log(passed, group, passinggrade, sectionTotal);
      commit('setSectionGrade', { group, passed });
      commit('setSectionPercentage', { group, perc });
    },
    setAnswer({ commit }, payload) {
      commit('setAnswer', payload);
    },
    setAnswered({ commit }, payload) {
      commit('setAnswered', payload);
    },
    setSectionGrade({ commit }, payload) {
      commit('setSectionGrade', payload);
    },
    setActiveSection({ commit }, payload) {
      commit('setActiveSection', payload);
    },
    setContact({ commit }, payload) {
      // console.log('commiting contact');
      commit('setContact', payload);
    },
    changeSection({ commit }, payload) {
      commit('setActiveSection', payload);
    },
    // submitdata({ commit, state }) {
    submitdata({ commit }) {
      // console.log('trying to submit');
      commit('submitdata');
      // if (state.submitted[0] === false) {
      //   console.log('sending to submit');
      // }
    },
  },
  mutations: {

    setActiveSection( state, data ) {
      state.activeSection = data;

    },

    pushAnswer(state, data) {
      state.answered[data.questionStep] = data.storeQuestion;

    },

    setNavStep(state, data) {
      state.navStep = data;
      // activeSection.push(data); // needs to be changed to support path and step

    },

    setNavPath(state, data) {
      state.navPath = data;

      switch (data) {

        // corresponds to CFO, setting currentPath
        case 1:
          state.currentPath = 'cfo';
          break;

        // corresponds to Controller, setting currentPath
        case 2:
          state.currentPath = 'controller';
          break;

        case 3:
          state.currentPath = 'apmanager';
          break;

        default:
          state.currentPath = 'opening';
          break;

      }

    },

    // Legacy
    setName({
      scores,
      totals,
      grades,
      answered,
      percentage,
    }, { group, name }) {
      // console.log('setting name of ', name);
      if (!scores[group]) {
        // console.log('resetting group ', group);
        scores[group] = {};
        totals[group] = {};
        answered[group] = false;
        percentage[group] = {};
        grades[group] = false;
      }
      scores[group][name] = 0;
      // answered[group] = false;
    },
    setScore({ scores }, { value, group, id }) {
      scores[group][id] = parseInt(value, 10);
    },
    setAnswer({ textresponses }, { question, response, group }) {
      textresponses[group] = {
        response,
        question,
      };
    },
    updateSectionScore({ totals }, { group, sectionTotal }) {
      totals[group] = sectionTotal;
    },
    setAnswered({ answered }, { group, check }) {
      answered[group] = check;
      // console.log(answered, check);
    },
    setContact({ contact }, payload) {
      Object.entries(payload).forEach((a) => {
        const key = a[0];
        const val = a[1];
        contact[key] = val;
      });
      // contact = payload;
      // console.log(' settting contact', contact);
    },
    setSectionGrade({ grades }, { group, passed }) {
      grades[group] = passed;
      // console.log(grades, passed);
    },
    setSectionPercentage({ percentage }, { group, perc }) {
      percentage[group] = perc;
      // console.log(percentage, perc);
    },
    // setActiveSection({ activeSection }, section) {
    //   console.log('setting active section', activeSection, section);
    //   activeSection.unshift(section);
    // },
    submitdata({ submitted }) {
      // console.log('setting as submitted');
      submitted.unshift(true);
    },
  },
  getters: {

    getNavPath(state) {
      return state.navPath;
    },

    getNavStep(state) {
      return state.navStep;
    },

    // legacy getters
    getscores(state) {
      return state.scores;
    },
    gettotals(state) {
      return state.totals;
    },
    getgrades(state) {
      return state.grades;
    },
    getpercentages(state) {
      return state.percentage;
    },
    getnav(state) {
      return state.nav;
    },
    getcontact(state) {
      return state.contact;
    },
    // getnavlength(state) {
    //   return state.nav.length();
    // },
    getActiveSection(state) {
      return state.activeSection;
    },
    getNextSection({ nav, activeSection }) {
      const currentInd = activeSection[0];
      // console.log('nav', nav.length);
      let nextSec = false;
      if (currentInd < nav.length) {
        nextSec = currentInd + 1;
      }
      return nextSec;
    },
    getPrevSection({ activeSection }) {
      const currentInd = activeSection[0];
      let prevSec = false;
      if (currentInd > 1) {
        prevSec = currentInd - 1;
      }
      return prevSec;
    },
    getAnswers({ textresponses }) {
      return textresponses;
    },
    issubmitted({ submitted }) {
      return submitted[0];
    },
    getAnswered({ answered }) {
      return answered;
      // const currentNav = nav[activeSection[0]].name.toLowerCase();
      // const currentGroup = scores[currentNav];
      // const currentGroupvals = Object.values(currentGroup);
      // const unansweredQs = currentGroupvals.filter((a) => a === 0);
      // if (
      //   unansweredQs.length > 0
      // ) {
      //   console.log('unanswered');
      //   return false;
      // }
      // console.log('answered',
      //   unansweredQs,
      //   currentNav,
      //   currentGroup,
      //   currentGroupvals);
      // return true;
    },
  },
});
